var exports = {
  "v": "createSpaceDialog__sHax-s",
};

module.exports = exports;
